<template>
  <div class="contents">
    <div v-for="(word, i) of optionsWithTotals" :key="word.id" class="flex items-center">
      <div class="flex-shrink-0 p-2">
        <div class="rounded-full w-12 h-12 relative" :style="{backgroundColor: colors[i]}"></div>
      </div>
      
      <div class="w-full flex flex-col">
        <div>{{word.text}}</div>
        <div class="relative h-3">
          <div class="absolute top-0 left-0 h-full bg-gray-500" :style="{width: 100 * word.total / voteTotal + '%'}"></div>
        </div>
      </div>
      <div class="flex-shrink-0 p-2">
        <span class="text-5xl">{{Math.round(100 * word.total / voteTotal)}}</span><span>%</span>
      </div>
    </div>
  </div>
</template>

<script>
import colors from '@/services/colors';

export default {
  data() {
    return {
      colors: colors,
    }
  },
  props: {
    use: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
  },
  computed: {
    optionsWithTotals() {
      return this.options.map(word => ({
        ...word,
        total: Object.values(this.use[word.id] || {}).reduce((sum, v) => sum + v, 0)
      }));
    },
    voteTotal() {
      return Object.values(this.use)
        .flatMap(v => Object.values(v))
        .reduce((a, b) => a + b, 0);
    }
  }
}
</script>